import type {NavigationGuardNext, RouteRecordNormalized} from "vue-router"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"
import {Capacitor} from "@capacitor/core"

export default class NotApp implements App.Middleware.Instance {
  async handle(
    to: RouteRecordNormalized,
    from: RouteRecordNormalized,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return next(to, from, cancel)
    }

    return cancel(route(ROUTES.LOGIN))
  }
}
